module.exports = __webpack_public_path__ + "static/media/3DPPA26.846049d4.jpg";